import { Box, IconButton, Stack, Typography } from "@mui/material";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { CSSProperties } from "react";

interface CardHeaderProps {
  title: string;
  isNavButtonDisabled?: boolean;
  onClickBack?: () => void;
  onClickClose?: () => void;
  hideBackIcon?: boolean;
  hideCloseIcon?: boolean;
}
export function CardHeader(props: CardHeaderProps) {
  return (
    <Stack
      direction={"row"}
      px={3}
      py={1.7}
      spacing={1}
      justifyContent={"flex-start"}
      alignItems={"center"}
    >
      {!props.hideBackIcon ? (
        <IconButton
          onClick={props.onClickBack}
          disabled={props.isNavButtonDisabled}
        >
          <KeyboardBackspaceRoundedIcon />
        </IconButton>
      ) : null}

      <Typography
        variant="h6"
        fontWeight={"700"}
        lineHeight={1.3}
        color="text.primary"
      >
        {props.title}
      </Typography>

      {!props.hideCloseIcon ? (
        <>
          <Box flexGrow={1} />
          <IconButton
            onClick={props.onClickClose}
            disabled={props.isNavButtonDisabled}
          >
            <CloseRoundedIcon />
          </IconButton>
        </>
      ) : null}
    </Stack>
  );
}

interface CardFooterProps {
  hidePrimaryButton?: boolean;
  hideSecondaryButton?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onClickPrimaryButton?: () => void;
  onClickSecondaryButton?: () => void;
  isLoadingPrimaryButton?: boolean;
  isLoadingSecondaryButton?: boolean;
  isDisabledPrimaryButton?: boolean;
  isDisabledSecondaryButton?: boolean;
  style?: {
    primaryButton?: CSSProperties;
    secondaryButton?: CSSProperties;
  };
}

export function CardFooter(props: CardFooterProps) {
  const { sm: smDown } = useCssMediaQuery("down");

  return (
    <Stack
      direction={"row"}
      justifyContent={smDown ? "flex-start" : "flex-end"}
      flexWrap={"wrap"}
      p={3}
      py={2}
      columnGap={2}
      rowGap={2}
    >
      {!props?.hideSecondaryButton ? (
        <ModalActionButton
          variant="secondary"
          isLoading={props.isLoadingSecondaryButton}
          onClick={props.onClickSecondaryButton}
          disabled={props.isDisabledSecondaryButton}
          style={props?.style?.secondaryButton}
        >
          {props.secondaryButtonText ? props.secondaryButtonText : "Close"}
        </ModalActionButton>
      ) : null}

      {!props?.hidePrimaryButton ? (
        <ModalActionButton
          variant="primary"
          isLoading={props.isLoadingPrimaryButton}
          disabled={props.isDisabledPrimaryButton}
          onClick={props.onClickPrimaryButton}
          style={props?.style?.primaryButton}
        >
          {props.primaryButtonText ? props.primaryButtonText : "Confirm"}
        </ModalActionButton>
      ) : null}
    </Stack>
  );
}
